// extracted by mini-css-extract-plugin
export default {"cls1":"WtgBffhGVw8gn1Z9l4oB","cls2":"I0nArPNwtSlrGL5VFB78 WtgBffhGVw8gn1Z9l4oB"};